import type { ActivityTypeFilterOption } from '@/hooks/useActivityTypesData';

/**
 * Mock activity-type filter options for demo mode.
 * Mirrors the canonical ActivityTypes lookup seeded in the database.
 */
export const mockActivityTypeFilterOptions: ActivityTypeFilterOption[] = [
  { value: 'call', label: 'Call' },
  { value: 'email', label: 'Email' },
  { value: 'note', label: 'Note' },
  { value: 'promise', label: 'Promise' },
  { value: 'status_change', label: 'Status Change' },
  { value: 'escalation', label: 'Escalation' },
  { value: 'account_action', label: 'Account Action' },
];
